/**
 * Open a link that has to be fetched first (a signed URL that expires in minutes) in a new tab.
 *
 * Safari, iOS above all, blocks window.open once the click's turn has passed, and returns null
 * without an error, so opening the tab after the request comes back did nothing on a phone.
 * The tab is opened inside the click and pointed at the URL when it arrives; it is closed again
 * when there is no URL or the request fails (AB#39901, 7.5.0 regression review of AB#40423).
 *
 * `fetchUrl` returns a promise of the URL. The returned promise rejects with the request's error.
 */
export const openSignedUrl = fetchUrl => {
  const tab = window.open('', '_blank')
  const closeTab = () => {
    if (tab && !tab.closed) tab.close()
  }
  return Promise.resolve()
    .then(fetchUrl)
    .then(
      url => {
        if (!url) {
          closeTab()
          return null
        }
        if (tab) {
          tab.opener = null
          tab.location.href = url
        } else {
          window.open(url, '_blank')
        }
        return url
      },
      error => {
        closeTab()
        throw error
      },
    )
}
